var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-circle-counter"},[_c('p',[_vm._v(_vm._s(_vm.title))]),_c('v-img',{style:({
      backgroundColor: _vm.color,
      borderRadius: '50%',
      maxHeight: '50px',
      maxWidth: '50px',
    })},[_c('p',{staticStyle:{"margin-top":"15px","color":"white"}},[_vm._v("\n      "+_vm._s(_vm.count)+"\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }